import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class UnidadeMedidaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        
        if (isNull(model.idpacoteerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("alert", 'msg-codigo-vazio', true));
        }
        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("alert", 'msg-atividade-obrigatorio-descricao', true));
        }
        if (isNull(model.idtabpreco)) {
            refs.tabelaPrecoSelect.focusedOut = true;
            validated = false;
            this.showMessage(new Message("alert", 'msg-erro-desc-qtd-tabpreco', true));
        }
        if (isNull(model.idempresa)) {
            refs.empresaSelect.focusedOut = true;
            validated = false;
            this.showMessage(new Message("alert", 'msg-obrigatorio-empresa', true));
        }

        return validated;
    }
}